import { render, staticRenderFns } from "./test-submit.vue?vue&type=template&id=209c3c0c&scoped=true&"
import script from "./test-submit.vue?vue&type=script&lang=js&"
export * from "./test-submit.vue?vue&type=script&lang=js&"
import style0 from "./test-submit.vue?vue&type=style&index=0&id=209c3c0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c3c0c",
  null
  
)

export default component.exports